module.exports = __webpack_public_path__ + "img/branched-log.0d7062af.svg";